import AppIconButton from '@nxsys/components/AppIconButton';
import { STATUTORY_PAYMENT_DETAIL_STATUS } from '@nxsys/constants/statutory';
import { Icons } from '@nxsys/types/icons';
import { getTaxWeekTaxYear } from '@nxsys/utils';
import { formatMoney } from '@nxsys/utils/number-helper';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';

export const getColumns = ({
  handleAddTimeSheet,
  messages,
  handleViewDetail,
}: {
  handleAddTimeSheet: (data: any) => void;
  messages: any;
  handleViewDetail: (type: string, id: string) => void;
}): ColumnsType<any> => {
  return [
    {
      key: 'actions',
      title: messages['statutory.column.actions'],
      fixed: 'left',
      align: 'left',
      render: (record) => (
        <ul className="table-actions flex items-center justify-center">
          <li
            onClick={() => handleViewDetail(record?.type, record?.statutoryId)}
          >
            <Tooltip title="Edit">
              <span><Icons.IconEdit /></span>
            </Tooltip>
          </li>
          {record.status === STATUTORY_PAYMENT_DETAIL_STATUS.NEW &&
            record.taxYear === getTaxWeekTaxYear().taxYear && (
              <li>
                <AppIconButton
                  title={messages['statutory.column.process']}
                  icon={<Icons.IconArrowExport />}
                  onClick={() => handleAddTimeSheet(record)}
                />
              </li>
            )}
        </ul>
      ),
      width: 100,
    },
    {
      key: 'type',
      title: messages['statutory.column.type'],
      dataIndex: 'type',
      align: 'center',
    },
    {
      key: 'amount',
      title: messages['statutory.column.amount'],
      align: 'right',
      render: (value) => formatMoney(value?.amount),
    },
    {
      key: 'taxWeek',
      title: messages['statutory.column.taxPeriod'],
      dataIndex: 'taxWeek',
      align: 'right',
    },
    {
      key: 'taxYear',
      title: messages['statutory.column.taxYear'],
      dataIndex: 'taxYear',
      align: 'right',
    },
    {
      key: 'id',
      title: messages['statutory.column.systemId'],
      dataIndex: 'id',
      width: 150,
    },
    {
      key: 'Forename',
      title: messages['statutory.column.forename'],
      dataIndex: 'forename',
      width: 150,
    },
    {
      key: 'Surname',
      title: messages['statutory.column.surname'],
      dataIndex: 'surname',
      width: 150,
    },
    {
      key: 'Agency Ref',
      title: messages['statutory.column.agencyRef'],
      render: (record) =>
        `${record?.agencyPrefix || '___'}/${
          record?.agencyRef || record?.id || '_'
        }`,
      width: 200,
    },
    {
      key: 'Primary Agency',
      title: messages['statutory.column.primaryAgency'],
      render: (record) => record?.primaryAgencyName,
      width: 250,
    },
    {
      key: 'Payment Company',
      title: messages['statutory.column.paymentCompany'],
      dataIndex: 'companyName',
      width: 250,
    },
  ];
};
